/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { OAuthFlow } from './OAuthFlow';

/**
 * Modles an implicit OAuth flow.
 * 
 * @author eric.wittmann@gmail.com
 * @class
 * @extends OAuthFlow
 */
export abstract class ImplicitOAuthFlow extends OAuthFlow {
    constructor() {
        super();
    }
}
ImplicitOAuthFlow["__class"] = "io.apicurio.datamodels.core.models.common.ImplicitOAuthFlow";
ImplicitOAuthFlow["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




